import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useOrgunitListData } from "../../Onboarding/hooks/useOnBoard";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import { useExcelPolling } from "../../../hooks/useExcelPolling";
import { showToast } from "../../../utils/toastUtils";
import axiosInstance from "../../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import { COLORS } from "../../../constants/colors";

const OrgListDataColumns = (handleViewClick: (row: any) => void) => [
  {
    name: "Organisation Unit",
    selector: (row: { UnitName: string }) => row.UnitName || "-",
    sortable: true,
  },
  {
    name: "Action",
    width: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          onClick={() => handleViewClick(row)}
          style={{
            backgroundColor: "#2e8dd3",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
  },
];

const OrgList = () => {
  const navigate = useNavigate();
  const { startPolling, stopPolling } = useExcelPolling();

  const [filterData, setFilterData] = useState({ search: ""});
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  const handleViewClick = (row: any) => {
    navigate(`/territories`, {
      state: { orgunitRowData: row },
    });
  };
  const { data: orgUnitsData, isLoading } = useOrgunitListData({
    params: { search: filterData.search,},
    enable: true,
  });

  const formattedTableData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any, index: any) => ({
      OrgunitId: item[0],
      OrgunitNames: item[1],
    })
  );

  const downloadExcelGet = async () => {
    const param: Record<string, any> = {};

    const queryString = new URLSearchParams(param).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.Beat.GET_EXCEL_BEAT_TERRITORIES}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } = response?.data?.data || null;

      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title="FSM"
        buttons={[
          // {
          //     label: "Import",
          //     onClick: () => alert("Action 3 clicked"),
          //     color: "#43B9B2",
          //   },
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        Title="Org List"
        handleSearch={(text: any) =>
          setFilterData((prev: any) => ({
            ...prev,
            search: text,
          }))
        }
        columns={OrgListDataColumns(handleViewClick)}
        data={orgUnitsData?.data || []}
        showSpinner={isLoading}
      />
    </div>
  );
};

export default OrgList;
